import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCLjcaouy6x7QS-odqyNwrT1F9eM4B6tnE",
  authDomain: "salonapp-1119c.firebaseapp.com",
  projectId: "salonapp-1119c",
  storageBucket: "salonapp-1119c.firebasestorage.app",
  messagingSenderId: "899391622339",
  appId: "1:899391622339:web:68f4f9d9dce076cf54e676",
  measurementId: "G-5HXV21JQPX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export default app;
